import React from 'react'

const Hero = () => {
  return (
    <div className="max-w-[1640px] mx-auto p-4">
        <div className="relative max-h-[500px]">
            {/* overlay */}
            <div className="absolute flex flex-col w-full h-full max-h-[500px] text-gray-200 
            justify-center bg-black/40">
                <h1 className="px-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold">The 
                <span className="text-orange-500"> Best</span></h1>
                <h1 className="px-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold"> 
                <span className="text-orange-500"> Foods</span> Delivered</h1>
            </div>
           <img src="https://images.pexels.com/photos/1639562/pexels-photo-1639562.jpeg"
            alt='' className="w-full max-h-[500px] object-cover"/>
            {/* <img src="../images/cover.jpg" alt='' className='w-full h-[100px]' /> */}
        </div>
    </div>
  )
}

export default Hero